module.exports = "/assets/js/f99f0fb8d1e286d36f2a7b8b7c8e14ed.svg";